import { render, staticRenderFns } from "./thirdpart.vue?vue&type=template&id=2c0bd025&scoped=true&"
import script from "./thirdpart.vue?vue&type=script&lang=js&"
export * from "./thirdpart.vue?vue&type=script&lang=js&"
import style0 from "./thirdpart.vue?vue&type=style&index=0&id=2c0bd025&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0bd025",
  null
  
)

component.options.__file = "thirdpart.vue"
export default component.exports